import type { ReactNode } from "react";
import { Link } from "react-router";
import { SearchX, type LucideIcon } from "lucide-react";
import { EmptyState } from "../../components/catalogue/Notices";
import { PageWidth } from "../../components/catalogue/StoreShell";
import { usePageTitle } from "./usePageTitle";

/**
 * PRD screen 20. Defaults speak to a missing part/page (also shown for a listing or diagram
 * that isn't, or is no longer, online). A caller in another context (e.g. a missing order)
 * passes its own copy so the message fits what the customer was actually looking for.
 */
export function NotFound({
  pageTitle = "Page not found",
  icon = SearchX,
  title = "We couldn't find that page",
  action = <Link to="/">Go to the catalogue</Link>,
  children = "It may have moved, or the part may no longer be sold. Start again from your machine.",
}: {
  pageTitle?: string;
  icon?: LucideIcon;
  title?: string;
  action?: ReactNode;
  children?: ReactNode;
} = {}) {
  usePageTitle(pageTitle);
  return (
    <PageWidth className="py-10">
      <EmptyState icon={icon} title={title} action={action}>
        {children}
      </EmptyState>
    </PageWidth>
  );
}
